import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { CreditNotesResponse } from '../models/credit.note/creditNotes.response';
import {CreditNote} from '../models/credit.note/creditNote.model';

@Injectable({
  providedIn: 'root'
})
export class CreditNoteService {

  constructor(private http: HttpClient) {
  }

  private CREDIT_NOTE_URL: string = environment.BASE_URL + 'credit/note';

  /**
   * GETS
   */
  public getCreditNotes(): Observable<CreditNotesResponse> {
    return this.http.get<CreditNotesResponse>(`${this.CREDIT_NOTE_URL}`).pipe();
  }

  public getCreditNote(id: string): Observable<CreditNote> {
    return this.http.get<CreditNote>(`${this.CREDIT_NOTE_URL}/${id}`).pipe(
    );
  }

  /**
   * CREATES
   */
  public createCreditNote(engine: CreditNote): Observable<CreditNote> {
    return this.http.post<CreditNote>(`${this.CREDIT_NOTE_URL}`, engine).pipe();
  }


  /**
   * UPDATES
   */
  public updateCreditNote(engine: CreditNote): Observable<CreditNote> {
    return this.http.patch<CreditNote>(`${this.CREDIT_NOTE_URL}/${engine.id}`, engine).pipe();
  }

  /**
   * DELETE
   */
  public deleteCreditNote(id: string): Observable<CreditNote> {
    return this.http.delete<CreditNote>(`${this.CREDIT_NOTE_URL}/${id}`).pipe();
  }

}
